import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "workflow-payload-editor" }
const _hoisted_2 = { class: "d-flex justify-space-between align-center mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_WorkflowPayloadNode = _resolveComponent("WorkflowPayloadNode")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("label", { class: "v-label" }, "Data Payload", -1)),
      _createVNode(_component_v_btn_toggle, {
        "model-value": _ctx.payloadViewMode,
        mandatory: "",
        density: "compact",
        variant: "outlined",
        "onUpdate:modelValue": _ctx.setPayloadViewMode
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, { value: "visual" }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("Visual")
            ])),
            _: 1,
            __: [1]
          }),
          _createVNode(_component_v_btn, { value: "json" }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("JSON")
            ])),
            _: 1,
            __: [2]
          })
        ]),
        _: 1
      }, 8, ["model-value", "onUpdate:modelValue"])
    ]),
    (_ctx.payloadViewMode === 'json')
      ? (_openBlock(), _createBlock(_component_v_textarea, {
          key: 0,
          "model-value": _ctx.localJson,
          "onUpdate:modelValue": _ctx.updateJson,
          "auto-grow": "",
          rows: "8",
          variant: "outlined",
          "error-messages": _ctx.jsonPayloadError
        }, null, 8, ["model-value", "onUpdate:modelValue", "error-messages"]))
      : (_openBlock(), _createBlock(_component_v_form, {
          key: 1,
          ref: "visualForm",
          onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_sheet, {
              class: "workflow-payload-editor__visual pa-4",
              variant: "outlined",
              rounded: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payloadTree, (node, index) => {
                  return (_openBlock(), _createBlock(_component_WorkflowPayloadNode, {
                    key: node.id,
                    node: node,
                    "parent-type": "object",
                    index: index,
                    depth: 0,
                    "validation-issues": _ctx.validationIssues,
                    onUpdate: _ctx.handleVisualUpdate,
                    onDelete: ($event: any) => (_ctx.removeRootField(index))
                  }, null, 8, ["node", "index", "validation-issues", "onUpdate", "onDelete"]))
                }), 128)),
                _createVNode(_component_v_btn, {
                  "prepend-icon": "mdi-plus",
                  variant: "outlined",
                  density: "compact",
                  class: "workflow-payload-editor__add-root",
                  onClick: _ctx.addRootField
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode(" Add Field ")
                  ])),
                  _: 1,
                  __: [4]
                }, 8, ["onClick"]),
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "workflow-payload-editor__root-note text-caption text-medium-emphasis" }, [
                  _createTextVNode(" Top level is a "),
                  _createElementVNode("span", { class: "font-weight-medium" }, "Group {}")
                ], -1))
              ]),
              _: 1,
              __: [5]
            })
          ]),
          _: 1
        }, 512))
  ]))
}